import React, { useEffect } from 'react';
import {
    useSsDispatch as useDispatch,
    useSsSelector as useSelector,
} from '~SpectateStore';
import { useTranslation } from 'react-i18next';

import {
    useIsUserLoggedIn,
    useShouldHideLogin,
} from '~SpectateStore/hooks/userHooks';

import {
    getRecommendations,
} from '~Betslip/thunks/getRecommendations';

import BetReceipt from '../../Components/BetReceipt';
import ContentTabs from '../../Components/ContentTabs';
import SelectionsList from '../../Components/SelectionsList';
import Notifications from '../../Components/Notifications';
import AcceptOddsChanges from '../../Components/AcceptOddsChanges';
import AvailableBetTypes from '../../Components/AvailableBetTypes';
import Recommendations from '../../Components/Recommendations';

import {
    selectShowBetReceipt,
} from '~Betslip/selectors/betReceiptSelectors';

const BetslipPage = () => {
    const [ t ] = useTranslation();
    const dispatch = useDispatch();
    const showBetReceipt = useSelector(selectShowBetReceipt);
    const isUserLoggedIn = useIsUserLoggedIn();
    const shouldHideLogin = useShouldHideLogin();

    if (shouldHideLogin) {
        return <div className="fullslip fullslip__no-betslip">
            <i className="fullslip__no-betslip-icon"></i>
            <span>{t('betslip.app_download')}</span>
        </div>;
    }

    useEffect(() => {
        dispatch(getRecommendations());
    }, [showBetReceipt]);

    if (showBetReceipt && isUserLoggedIn) {
        return <BetReceipt />;
    }

    return (
        <>
            <div className="fullslip__content">
                <ContentTabs />
                <SelectionsList />
                <Recommendations />
            </div>

            <div className="fullslip__toBottom"></div>

            <Notifications />
            <AcceptOddsChanges source="new-betslip"/>
            <AvailableBetTypes />
        </>
    );
};

export default BetslipPage;
